// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"d6c843bb","444":"ce0d21b9","511":"481dbd3a","708":"d253182a"}[chunkId] + ".css";
};